<template>
	<v-app>
		<v-app-bar
			app
			color="primary"
			dark
		>
			<div class="d-flex align-center">
				ETES Shift Selector
			</div>

			<v-tabs
				v-if="token"
				v-model="tab"
				centered
			>
				<v-tab key="schedule">Schedule</v-tab>
				<v-tab key="overview">Overview</v-tab>
				<v-tab key="team-agenda" v-if="userData && userData.isCaptain">Team agenda</v-tab>
				<v-tab key="team" v-if="userData && userData.isCaptain">Tasks per person</v-tab>
				<v-tab key="all-teams" v-if="userData && userData.isOrga">Agendas per team</v-tab>
			</v-tabs>

			<v-btn
				v-if="token"
				@click="logout"
				text
			>
				<span class="mr-2">Log out</span>
			</v-btn>
		</v-app-bar>

		<v-main>
			<ShiftSelector
				v-if="token"
				:tab="tab"
				:token="token"
				:userData="userData"/>
			<v-row v-else class="text-center">
				<v-col class="mb-4">
					<v-text-field
						v-model="etesId"
						label="ETES ID"
					></v-text-field>
					<v-text-field
						v-model="password"
						label="Password"
						type="password"
					></v-text-field>
					<v-btn @click="login">Log in</v-btn>
				</v-col>
			</v-row>

		</v-main>
		<v-snackbar v-model="showErrorMessage">{{errorMessage}}</v-snackbar>
	</v-app>
</template>

<script>
	import ShiftSelector from './components/ShiftSelector';
	import axios from "axios";

	export default {
		name: 'App',

		components: {
			ShiftSelector,
		},

		data: () => ({
			tab: '0',
			etesId: '',
			password: '',
			token: null,
			userData: {},
			errorMessage: '',
			showErrorMessage: false,
		}),
		watch: {
			token: async function(token) {
				if (token) {
					this.userData = (await axios.get(`/users/me`)).data;
				}
			}
		},
		created: function() {
			// axios.defaults.baseURL = 'http://localhost:3000';
			axios.defaults.baseURL = 'https://etes-api-16354.nodechef.com';
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			if (params.token) {
				localStorage.token = params.token;
			}
			const token = params.token || localStorage.token;
			axios.defaults.headers = {
				'Content-Type': 'application/json',
			};
			if (token) {
				axios.defaults.headers.Authorization = `Bearer ${token}`;
				this.token = token;
			} else {
				this.userData = null;
			}
		},
		methods: {
			loadUserData: async function() {
				this.userData = (await axios.get(`/users/me`)).data;
			},
			login: async function() {
				try {
					const result = await axios.post(`/sessions/`, {username: this.etesId, password: this.password});
					console.log('login result', result);
					axios.defaults.headers.Authorization = `Bearer ${result.data.token}`;
					this.token = localStorage.token = result.data.token;
					await this.loadUserData();
				} catch (e) {
					console.error('request failed', e.response.data);
					this.errorMessage = 'Login failed';
					this.showErrorMessage = true;
				}
			},
			logout: function() {
				window.localStorage.clear();
				window.document.location.reload();
			}
		}
	};
</script>

<style scoped>
	@media print {
		header, footer, aside, nav, form, iframe, .menu, .hero, .adslot {
			display: none;
		}
	}
</style>
